import { useIsWindowBiggerThan } from '@bob/library'
import React, { FC } from 'react'

export interface WaveProps {
  className?: string
}
export const Wave: FC<WaveProps> = ({ className }) => {
  const isTablet = useIsWindowBiggerThan(719)
  const isDesktop = useIsWindowBiggerThan(1079)
  const isWideScreen = useIsWindowBiggerThan(1439)
  const isUltraWideScreen = useIsWindowBiggerThan(1919)

  if (isUltraWideScreen) {
    return (
      <svg
        className={className}
        fill={'none'}
        height={'46'}
        viewBox={'0 0 3840 46'}
        width={'100%'}
        xmlns={'http://www.w3.org/2000/svg'}
      >
        <path
          d={
            'M-239.5 11.4964V44.5H1199.5V11.9851L1084.07 8.49977L1084.03 8.49858L1083.99 8.49116L1042.08 0.502427L944.703 5.49934L944.678 5.50062L944.653 5.49942L882.209 2.5H846.255H846.246L671.885 8.9998L671.873 8.99996L521.978 11L521.96 11.0002L521.943 10.9992L413.047 5H413.033H400.563H400.555L324.624 7.49973L324.595 7.50071L324.565 7.49814L255.146 1.50102L128.268 7.49944L128.244 7L128.268 7.49946L63.8123 10.4995L63.7812 10.5009L63.7501 10.4985L-6.67236 5.00071L-171.529 10.9997L-171.536 10.9999L-171.544 11L-239.5 11.4964Z'
          }
          fill={'#141414'}
          stroke={'#141414'}
        />
        <path
          d={
            'M2639.5 11.4964V44.5H1200.5V11.9851L1315.93 8.49977L1315.97 8.49858L1316.01 8.49116L1357.92 0.502427L1455.3 5.49934L1455.32 5.50062L1455.35 5.49942L1517.79 2.5H1553.74H1553.75L1728.11 8.9998L1728.13 8.99996L1878.02 11L1878.04 11.0002L1878.06 10.9992L1986.95 5H1986.97H1999.44H1999.44L2075.38 7.49973L2075.41 7.50071L2075.44 7.49814L2144.85 1.50102L2271.73 7.49944L2271.76 7L2271.73 7.49946L2336.19 10.4995L2336.22 10.5009L2336.25 10.4985L2406.67 5.00071L2571.53 10.9997L2571.54 10.9999L2571.54 11L2639.5 11.4964Z'
          }
          fill={'#141414'}
          stroke={'#141414'}
        />
        <path
          d={
            'M2640.5 11.4964V44.5H4079.5V11.9851L3964.07 8.49977L3964.03 8.49858L3963.99 8.49116L3922.08 0.502427L3824.7 5.49934L3824.68 5.50062L3824.65 5.49942L3762.21 2.5H3726.26H3726.25L3551.89 8.9998L3551.87 8.99996L3401.98 11L3401.96 11.0002L3401.94 10.9992L3293.05 5H3293.03H3280.56H3280.56L3204.62 7.49973L3204.59 7.50071L3204.56 7.49814L3135.15 1.50102L3008.27 7.49944L3008.24 7L3008.27 7.49946L2943.81 10.4995L2943.78 10.5009L2943.75 10.4985L2873.33 5.00071L2708.47 10.9997L2708.46 10.9999L2708.46 11L2640.5 11.4964Z'
          }
          fill={'#141414'}
          stroke={'#141414'}
        />
      </svg>
    )
  } else if (isWideScreen) {
    return (
      <svg
        className={className}
        fill={'none'}
        height={'46'}
        viewBox={'0 0 1920 46'}
        width={'100%'}
        xmlns={'http://www.w3.org/2000/svg'}
      >
        <path
          d={
            'M154.571 8.68542L154.601 8.68474L154.63 8.68051L210.546 0.686917L340.411 5.68518L340.43 5.68589L340.448 5.68522L423.706 2.68555H423.715H471.665H471.672L704.164 9.18543L704.173 9.18552L904.034 11.1855L904.047 11.1856L904.06 11.1851L1049.27 5.18555H1049.28H1065.92H1065.93L1167.18 7.68539L1167.2 7.68595L1167.22 7.6845L1259.8 1.68612L1428.99 7.68523L1429.01 7.18555L1428.99 7.68524L1514.93 10.6852L1514.95 10.6861L1514.98 10.6847L1608.87 5.18536L1608.89 5.18595L1828.72 11.1855L1828.73 11.1855L1919.5 11.6828V44.6855H0.5V12.1744L154.571 8.68542Z'
          }
          fill={'#141414'}
          stroke={'#141414'}
        />
      </svg>
    )
  } else if (isDesktop) {
    return (
      <svg
        className={className}
        fill={'none'}
        height={'46'}
        viewBox={'0 0 1439 46'}
        width={'100%'}
        xmlns={'http://www.w3.org/2000/svg'}
      >
        <path
          d={
            'M115.435 8.63893L115.474 8.63774L115.513 8.63032L157.425 0.641588L254.797 5.6385L254.822 5.63978L254.847 5.63858L317.291 2.63916H353.245H353.254L527.615 9.13896L527.627 9.13912L677.522 11.1391L677.54 11.1393L677.557 11.1384L786.453 5.13916H786.467H798.937H798.945L874.876 7.63889L874.905 7.63987L874.935 7.6373L944.354 1.64018L1071.23 7.6386L1071.26 7.13916L1071.23 7.63862L1135.69 10.6386L1135.72 10.6401L1135.75 10.6376L1206.17 5.13987L1371.03 11.1388L1371.04 11.1391L1371.04 11.1391L1439 11.6355V44.6392H0V12.1243L115.435 8.63893Z'
          }
          fill={'#141414'}
          stroke={'#141414'}
        />
      </svg>
    )
  } else if (isTablet) {
    return (
      <svg
        className={className}
        fill={'none'}
        height={'46'}
        viewBox={'0 0 1079 46'}
        width={'100%'}
        xmlns={'http://www.w3.org/2000/svg'}
      >
        <path
          d={
            'M86.4597 8.63876L86.512 8.63665L86.5628 8.62376L117.963 0.643453L190.958 5.63799L190.991 5.64025L191.024 5.63814L237.85 2.63916H264.803L395.575 9.13854L395.583 9.13894L395.591 9.13908L508.013 11.1391L508.036 11.1395L508.058 11.1378L589.733 5.13916H599.073H599.084L656.022 7.63868L656.062 7.64042L656.101 7.63588L708.146 1.64097L803.285 7.63817L803.286 7.6382L851.627 10.6382L851.669 10.6408L851.71 10.6365L904.51 5.14042L1028.14 11.1386L1028.15 11.139L1028.16 11.1391L1079 11.6343V44.6392H0V12.1194L86.4597 8.63876Z'
          }
          fill={'#141414'}
          stroke={'#141414'}
        />
      </svg>
    )
  }
  return (
    <svg
      className={className}
      fill={'none'}
      height={'46'}
      viewBox={'0 0 368 46'}
      width={'100%'}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <path
        d={
          'M-118.01 9.11481L-117.934 9.1102L-117.862 9.08293L-96.9877 1.12524L-48.3897 6.11311L-48.3403 6.11818L-48.2908 6.11343L-17.0864 3.11572H0.858536L88.0294 9.61434L88.0414 9.61523L88.0533 9.61554L163.001 11.6155L163.035 11.6165L163.069 11.6127L217.504 5.61572H223.706L261.663 8.11464L261.723 8.11855L261.781 8.10842L296.441 2.11978L359.831 8.1135L359.831 8.11357L392.059 11.1136L392.121 11.1193L392.183 11.1097L427.352 5.61855L509.737 11.6144L509.752 11.6155L509.766 11.6157L543.5 12.1085V45.1157H-175.5V12.5864L-118.01 9.11481Z'
        }
        fill={'#141414'}
        stroke={'#141414'}
      />
    </svg>
  )
}
